import React, { CSSProperties, ReactElement } from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { ReactComponent as BlankArrow } from 'app/assets/img/blank_arrow.svg';
import { MOBILE_WIDTH } from 'app/hooks/useWindowSize';
import { selectTranslations } from 'app/pages/App/slice/selectors';

const GrandstandDiagram = (props: {
  grandstandData?: Record<string, any>;
  activeElm?: ReactElement;
  textCSS?: CSSProperties;
  displayDiagram?: string;
}) => {
  const translations = useSelector(selectTranslations);

  if (!props?.grandstandData?.image?.original) {
    return <div></div>;
  }
  return (
    <PhotoProvider maskOpacity={0.7}>
      <PhotoView src={props?.grandstandData?.image?.original}>
        {props.activeElm || (
          <Text style={props.textCSS}>
            {props?.displayDiagram ||
              translations?.['b2c.text.grandstand-diagram']}{' '}
            <BlankArrow style={{ marginLeft: 7 }} />
          </Text>
        )}
      </PhotoView>
    </PhotoProvider>
  );
};

export default GrandstandDiagram;

const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #f8b117;
  display: flex;
  align-items: center;
  margin-top: 13px;
  cursor: pointer;
  @media (max-width: ${MOBILE_WIDTH}px) {
    margin-top: 2px;
  }
`;
